import React from 'react'
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite';
import * as FPT from '../utility/fpt'

const styles = StyleSheet.create({
	wrapper: {},
	toolWrapper: {
		marginTop: '20px',
		position: 'relative'
	},
	toolCheckboxWrapper: {
		position: 'absolute',
		width: 'inherit',
		display: 'inline',
	},
	toolCheckbox: {
		':before': {
			overflow: 'hidden',
		},
	},
	toolBlurb: {
		fontSize: '15px',
		lineHeight: '20px',
		marginLeft: '40px',
		fontFamily: 'pp-sans-small-regular',
	},
	toolTip: {
		position: 'relative',
		// display: 'none',
		maxWidth: '430px',
		margin: '5px auto',
	},
	tipIcon: {
		color: '#005EA6',
		cursor: 'pointer',
		textDecoration: 'none',
	},
	toolTipTxt: {
		backgroundColor: '#e1e7eb',
		fontSize: '12px',
		lineHeight: '1.8',
		textAlign: 'left',
		borderRadius: '6px',
		padding: '5px 7px',
		display: 'block',
	}
})

class AddressCheckBox extends React.Component {

	constructor() {
		super();
		this.state = {
			showToolTip: false
		};
	}

	handleTipClick = (event) => {
		event.preventDefault();
		let { showToolTip } = this.state;
		this.setState({ showToolTip: showToolTip = !showToolTip });
	}

	handleChangeAddress = (ev) => {
		let isChecked = ev.target.checked;
		let chkBxStatus = isChecked ? 'checked' : 'unchecked';
		FPT.trackLinkClickWithData('shareAddress', { checkbox: chkBxStatus });

		this.props.changeAddress(isChecked);
	}

	render () {
		return (
			<div className={`row ${css(styles.wrapper)}`}>
				<div className="col-xs-12 col-sm-12 col-md-12">
					<div className={css(styles.toolWrapper)}>
						<div className={`vx_checkbox ${css(styles.toolCheckboxWrapper)}`}>
							<input type="checkbox" id="shareAddressCheckbox" onChange={this.handleChangeAddress} />
							<label htmlFor="shareAddressCheckbox" className={css(styles.toolCheckbox)}>
								<span className="sr-only">{this.props.label}</span>
							</label>
						</div>
						<p className={css(styles.toolBlurb)}>{this.props.label}
							<a href="#" onClick={this.handleTipClick}
								 className={`icon icon-small icon-tooltip-outline-small ${css(styles.tipIcon)}`}
								aria-hidden="true">
							</a>
						</p>
					</div>
				</div>
				{this.state.showToolTip && <div id="toolTip" className={`col-xs-12 col-sm-12 col-md-12 ${css(styles.toolTip)}`}>
					<span className={css(styles.toolTipTxt)}>{this.props.toolTipText}</span>
				</div>}
			</div>
		);
	}
}

AddressCheckBox.propTypes = {
	changeAddress: PropTypes.func.isRequired,
	toolTipText: PropTypes.string,
	label: PropTypes.string,
};

export default AddressCheckBox



// WEBPACK FOOTER //
// ./components/addressCheckbox.js